import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import BoardModal from "./BoardModal";
import { useSelector } from "react-redux";
import ErrorAdd from "../../../util/ErrorAdd";

function BoardModalAdd({ show, onHide, idProject }) {


    const [modalEditShow, setModalEditShow] = useState(false);

    const [name, setName] = useState(null);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState(null);

    /*
    ID	Name	            Description
    1	Проект/ожидание	    Задачи на доске ни на что не влияют.
    2	В работе	        При перемещении на доску считается что по задаче начались работы.
    3	Завершена	        При перемещении на доску считается что по задаче закончились работы. Задача завершена. 
    */

    const [typeParamSelected, setTypeParamSelected] = useState(null);
    const stateData = useSelector((state) => state.data);

    function update() {

        setLog(null);

        if (name == null || name == '' || name == undefined) {
            setLog('Введите название доски');
        }
        else if (typeParamSelected === null) {
            setLog('Выберите тип доски');
        }
        else {
            //Если тип "Завершена", то заполняем тип завершения "Нажатием кнопки в архив"
            const ID_Type_Setting = typeParamSelected === 3 ? 1 : null;

            axios.post('/api_tracker/board/add', { ID_Type: typeParamSelected, Name: name, Projects: [idProject], ID_Type_Appointment: 5, ID_Type_Display_Task: 1, ID_Type_Archive: ID_Type_Setting })
                .then((res) => {
                    if (res.data.Status === 1) {
                        const id = res.data.Data;

                        axios.get('/api_tracker/board/get', { params: { ID: id } })
                            .then((res1) => {
                                if (res1.data.Status === 1) {
                                    setModel(res1.data.Data);
                                    setModalEditShow(true);
                                    setLoading(false);
                                    onHide();
                                }
                                else {
                                    setLog(res1.data.Error);
                                    setLoading(false);
                                }
                            })
                            .catch((err) => {
                                setLog('Неизвестная ошибка!');
                                setLoading(false);
                            });
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            {modalEditShow === true && (
                <BoardModal show={modalEditShow} onHide={() => setModalEditShow(false)} projectSelected={idProject} model={model} />
            )}

            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center">Добавление доски</div>
                    <div className="mt-15">
                        <input type="text" className="form-control" disabled={loading} placeholder="Введите название..." onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="mt-10 row">
                        {stateData.boardType.map(item => (
                            <div key={item.id} className="col-4 mt-10">
                                <button className={'param_button' + (item.id === typeParamSelected ? ' active' : '')} onClick={() => setTypeParamSelected(item.id)}>
                                    <i className="mr-5"><FontAwesomeIcon icon={item.icon} /></i>
                                    {item.id === 1 ? 'Проект' : item.name}
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="mt-15 row">
                        {stateData.boardType.map(item => (
                            <div key={item.id} className="mt-10">
                                <b><i className="mr-5"><FontAwesomeIcon icon={item.icon} /></i>{item.name} </b>- {item.description}
                            </div>
                        ))}
                    </div>
                    <div className="text_error text-center mt-10">{log}</div>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="add" size='lg' loading={loading} onClick={() => update()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}

export default BoardModalAdd;